import { selectDocLinkUrlPrefix } from "../../../app/state/config/ConfigSelectors";
import type { RootState } from "../../../app/state/RootState";

import { type DocLinkSlug, doCreateDocLinkUrl } from "./AllDocLinkSlugs";

export function createDocLinkUrl(rootState: RootState, slug: DocLinkSlug): string {
	return doCreateDocLinkUrl(selectDocLinkUrlPrefix(rootState), slug);
}
